import React from 'react';

import { COMPANY_TYPES } from '../../constants/constants';

const setSearchFilter = ((value, props) => {
  const { setSearchFilter, getCompanyTypeListings, companyType, user } = props;
  setSearchFilter(value);
  getCompanyTypeListings(companyType, user && user.id ? user.id : navigator.userAgent);
});

const SearchCompanySection = (props) => {
  const { companyType, filter } = props;
  const companyNameToBeShown = COMPANY_TYPES.find(({ name }) => name === companyType);
  return (
    <section className="banner school-listing-banner faq-banner gen-banner">
      <div className="container">
        <div className="row  ">
          <div className="col-12">
            <div className="banner-text-box text-center text-wrap">
              <h1 className="mb-3">{companyNameToBeShown.pluralName} Around the World</h1>
              <p className="">Our FAQs contain advice for setting up accounts and campaigns, donating and our most common questions. Search the FAQs below.</p>
              <div className="search-box">
                <input value={filter && filter.name ? filter.name : ''} onChange={({ target }) => setSearchFilter(target.value, props)} type="search" className="form-control  " name="" placeholder={`Search ${companyNameToBeShown.title}`} />
                <i className="fa fa-search search-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SearchCompanySection;